/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Ratings constants
 */

export const START_FETCHING_RATINGS = '@@nzr/Detail/START_FETCHING_RATINGS'
export const CLEAR_RATINGS = '@@nzr/Detail/CLEAR_RATINGS'
export const DONE_FETCHING_RATINGS = '@@nzr/Detail/DONE_FETCHING_RATINGS'
export const ERROR_FETCHING_RATINGS = '@@nzr/Detail/ERROR_FETCHING_RATINGS'
export const RECEIVE_RATINGS = '@@nzr/Detail/RECEIVE_RATINGS'
export const CANCEL_FETCHING_RATINGS = '@@nzr/Detail/CANCEL_FETCHING_RATINGS'
